export const baseURL = "http://localhost";
export const errorMsg = {
    401: "Please log in again",
    500: "Failed to connect to server",
};
